import { render, staticRenderFns } from "./TestCorrectionDemoPlayer.vue?vue&type=template&id=5e411b3d&scoped=true"
import script from "./TestCorrectionDemoPlayer.vue?vue&type=script&lang=js"
export * from "./TestCorrectionDemoPlayer.vue?vue&type=script&lang=js"
import style0 from "./TestCorrectionDemoPlayer.vue?vue&type=style&index=0&id=5e411b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e411b3d",
  null
  
)

export default component.exports